import api from './api-service';
import _ from 'lodash';

const SessionService = {
	getSession() {
		return api.client.get('/session')
			.then((res) => {
				return {
					...res.data,
					studioLogo: () => {
						if(res.data.studios?.length === 1) {
							return res.data.studios[0].$links.logo;
						}

						return '/img/pixwel.logo.png';
					},
					isAdmin: () => {
						return _.chain(res.data.groups)
							.map('type')
							.includes('a')
							.value();
					}
				};
			});
	},

	getStudioLogo(session) {
		if( session.studios?.length === 1 ) {
			return session.studios[0].$links.logo;
		}

		return '/img/pixwel.logo.png';
	}
};

export default SessionService;
